import { SVGProps } from 'react';
const EmptyDataFound = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" rx="32" fill="#F3F4F6" />
    <path
      d="M40.8424 17.2656V20.213M23.1582 17.2656V20.213"
      stroke="#74797E"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.7383 26.1094H45.2646"
      stroke="#74797E"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 32.3599C18 25.9386 18 22.728 19.8452 20.7331C21.6905 18.7383 24.6603 18.7383 30.6 18.7383H33.4C39.3397 18.7383 42.3095 18.7383 44.1548 20.7331C46 22.728 46 25.9386 46 32.3599V33.1167C46 39.538 46 42.7486 44.1548 44.7434C42.3095 46.7383 39.3397 46.7383 33.4 46.7383H30.6C24.6603 46.7383 21.6905 46.7383 19.8452 44.7434C18 42.7486 18 39.538 18 33.1167V32.3599Z"
      stroke="#74797E"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.3164 32.7383L32.0006 36.4225M32.0006 36.4225L35.6848 40.1067M32.0006 36.4225L35.6848 32.7383M32.0006 36.4225L28.3164 40.1067"
      stroke="#74797E"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EmptyDataFound;
